<app-breadcrumb
  [title]="curentLang === 'en' ? 'Product Categories' : (curentLang === 'ar' ? 'تصنيفات المنتجات' : 'קטגוריות מוצרים')"
  [items]="curentLang === 'en' ? ['Dashboard'] : (curentLang === 'ar' ? ['لوحة التحكم'] : ['לוח בקרה'])"
  [active_item]="curentLang === 'en' ? 'Product Categories' : (curentLang === 'ar' ? 'تصنيفات المنتجات' : 'קטגוריות מוצרים')">
</app-breadcrumb>

<div class="container-fluid basic_table">
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header d-flex justify-content-between">
          <h5 style="color: grey;">
            {{ curentLang === 'en' ? 'Product Categories' : (curentLang === 'ar' ? 'تصنيفات المنتجات' : 'קטגוריות מוצרים') }}
          </h5>
          <div>
            <button class="btn m-1" style="background-color:#141414;color:#fff;" (click)="openAddCategoryModal()">
              <i class="fa fa-plus-circle mx-1"></i>
              {{ curentLang === 'en' ? 'Add Category' : (curentLang === 'ar' ? 'إضافة تصنيف' : 'הוספת קטגוריה') }}
            </button>
            <button class="btn m-1 btn-outline-warning" (click)="getAllCategories()">
              <i class="fa fa-refresh mx-1"></i>
              {{ curentLang === 'en' ? 'Refresh' : (curentLang === 'ar' ? 'تحديث' : 'רענון') }}
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-5">
            <div class="form-group search m-3">
              <label class="ml-2" style="color:grey;">
                {{ curentLang === 'en' ? 'Search' : (curentLang === 'ar' ? 'بحث' : 'חיפוש') }}
              </label>
              <input class="form-control w-100" type="text" [(ngModel)]="term"
                [ngModelOptions]="{standalone: true}" (input)="onSearchInput()"
                [placeholder]="curentLang === 'en' ? 'Search' : (curentLang === 'ar' ? 'بحث' : 'חיפוש')" />
            </div>
          </div>
        </div>

        <div class="card-block row">
          <div class="col-sm-12">
            <div class="table-responsive d-none d-lg-block">
              <table class="table table-light text-center table-hover">
                <thead>
                  <tr>
                    <th>{{ curentLang === 'en' ? '#' : (curentLang === 'ar' ? 'م' : 'מ') }}</th>
                    <th>{{ curentLang === 'en' ? 'Image' : (curentLang === 'ar' ? 'صورة' : 'תמונה') }}</th>
                    <th>{{ curentLang === 'en' ? 'Name' : (curentLang === 'ar' ? 'الاسم' : 'שם') }}</th>
                    <th>{{ curentLang === 'en' ? 'Code' : (curentLang === 'ar' ? 'الكود' : 'קוד') }}</th>
                    <th>{{ curentLang === 'en' ? 'Sort' : (curentLang === 'ar' ? 'الترتيب' : 'סדר') }}</th>
                    <th>{{ curentLang === 'en' ? 'Status' : (curentLang === 'ar' ? 'الحالة' : 'סטטוס') }}</th>
                    <th>{{ curentLang === 'en' ? 'Created' : (curentLang === 'ar' ? 'تاريخ التسجيل' : 'תאריך') }}</th>
                    <th>{{ curentLang === 'en' ? 'View' : (curentLang === 'ar' ? 'عرض' : 'הצגה') }}</th>
                    <th>{{ curentLang === 'en' ? 'Update' : (curentLang === 'ar' ? 'تعديل' : 'עריכה') }}</th>
                    <th>{{ curentLang === 'en' ? 'Delete' : (curentLang === 'ar' ? 'حذف' : 'מחיקה') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of categoriesData | paginate: {itemsPerPage:50, currentPage:p}; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>
                      <img *ngIf="item.image_url" [src]="item.image_url" alt="" class="category-thumb category-thumb-clickable"
                        (click)="executeFunctionsView(categoryPk(item), viewData)"
                        [title]="curentLang === 'en' ? 'View' : (curentLang === 'ar' ? 'عرض' : 'הצגה')" />
                      <span *ngIf="!item.image_url" class="text-muted">—</span>
                    </td>
                    <td>{{ displayName(item) }}</td>
                    <td>{{ item.code || '—' }}</td>
                    <td>{{ item.sort_order ?? 0 }}</td>
                    <td>
                      <button *ngIf="categoryStatus(item)==1" class="btn border-0"
                        (click)="changeStatus(categoryPk(item), categoryStatus(item))">
                        <i class="fa fa-toggle-on" style="color:#213FA6;"></i>
                      </button>
                      <button *ngIf="categoryStatus(item)==59" class="btn border-0"
                        (click)="changeStatus(categoryPk(item), categoryStatus(item))">
                        <i class="fa fa-toggle-off" style="color:red;"></i>
                      </button>
                    </td>
                    <td>{{ item.createdDate | date:'dd/MM/yyyy' }}</td>
                    <td>
                      <button class="btn border-0" (click)="executeFunctionsView(categoryPk(item), viewData)">
                        <i class="fa fa-eye" style="color:grey;"></i>
                      </button>
                    </td>
                    <td>
                      <button class="btn border-0" (click)="executeFunctions(categoryPk(item), updatedData)">
                        <i class="fa fa-edit" style="color:green;"></i>
                      </button>
                    </td>
                    <td>
                      <button class="btn border-0"
                        [ngStyle]="{ 'pointer-events': categoryStatus(item)==1 ? 'none' : 'auto', 'color': categoryStatus(item)==1 ? 'gray' : 'red' }"
                        (click)="getId(categoryPk(item)); openVerticallyCentered(dataDeleted)">
                        <i class="fa fa-trash-o"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="crud-cards-list d-lg-none">
              <div class="crud-card" *ngFor="let item of categoriesData | paginate: {itemsPerPage:50, currentPage:p}">
                <div class="cc-header">
                  <div class="cc-avatar" *ngIf="!item.image_url">
                    <span>{{ displayName(item)?.charAt(0)?.toUpperCase() || '?' }}</span>
                  </div>
                  <img *ngIf="item.image_url" [src]="item.image_url" alt="" class="cc-avatar-img category-thumb-clickable"
                    (click)="executeFunctionsView(categoryPk(item), viewData)" />
                  <div class="cc-title-block">
                    <div class="cc-name">{{ displayName(item) }}</div>
                    <div class="cc-sub">{{ item.code || '—' }} · #{{ item.sort_order ?? 0 }}</div>
                  </div>
                  <span class="cc-badge"
                    [style.background]="categoryStatus(item)==1 ? '#e8f5e9' : '#f5f5f5'"
                    [style.color]="categoryStatus(item)==1 ? '#2e7d32' : '#757575'">
                    {{ categoryStatus(item)==1
                      ? (curentLang === 'ar' ? 'نشط' : (curentLang === 'he' ? 'פעיל' : 'Active'))
                      : (curentLang === 'ar' ? 'غير نشط' : (curentLang === 'he' ? 'לא פעיל' : 'Inactive')) }}
                  </span>
                </div>
                <div class="cc-actions">
                  <button class="cc-action-btn cc-action-view" (click)="executeFunctionsView(categoryPk(item), viewData)">
                    <i class="fa fa-eye"></i>
                  </button>
                  <button class="cc-action-btn cc-action-edit" (click)="executeFunctions(categoryPk(item), updatedData)">
                    <i class="fa fa-edit"></i>
                  </button>
                  <button class="cc-action-btn cc-action-delete"
                    [attr.disabled]="categoryStatus(item)==1 ? true : null"
                    (click)="getId(categoryPk(item)); openVerticallyCentered(dataDeleted)">
                    <i class="fa fa-trash-o"></i>
                  </button>
                </div>
              </div>
            </div>

            <pagination-controls (pageChange)="p = $event" class="m-auto my-3 current"></pagination-controls>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Update -->
<ng-template #updatedData let-modal>
  <div class="modal-header d-flex justify-content-between">
    <h6 class="modal-title" style="color:grey;">
      {{ curentLang === 'en' ? 'Update Category' : (curentLang === 'ar' ? 'تعديل التصنيف' : 'עריכת קטגוריה') }}
    </h6>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="updateForm" novalidate [ngClass]="{ 'was-validated': validateUpdate }">
      <div class="row">
        <div class="mb-3 col-md-12">
          <label class="form-label" style="color:grey;">
            {{ curentLang === 'en' ? 'Name' : (curentLang === 'ar' ? 'الاسم' : 'שם') }}
            <span class="text-danger">*</span>
          </label>
          <input class="form-control" formControlName="name" maxlength="80"
            [placeholder]="curentLang === 'en' ? 'Category name' : (curentLang === 'ar' ? 'اسم التصنيف' : 'שם קטגוריה')" />
        </div>
        <div class="mb-3 col-md-6">
          <label class="form-label" style="color:grey;">
            {{ curentLang === 'en' ? 'Code' : (curentLang === 'ar' ? 'الكود' : 'קוד') }}
          </label>
          <input class="form-control" formControlName="code" maxlength="40" />
        </div>
        <div class="mb-3 col-md-6">
          <label class="form-label" style="color:grey;">
            {{ curentLang === 'en' ? 'Sort Order' : (curentLang === 'ar' ? 'الترتيب' : 'סדר') }}
          </label>
          <input class="form-control" type="number" formControlName="sort_order" />
        </div>
        <div class="mb-3 col-md-12">
          <label class="form-label" style="color:grey;">
            {{ curentLang === 'en' ? 'Category Image' : (curentLang === 'ar' ? 'صورة التصنيف' : 'תמונת קטגוריה') }}
          </label>
          <div class="d-flex flex-wrap align-items-center gap-3">
            <img *ngIf="currentImageUrl" [src]="currentImageUrl" alt="" class="category-image-preview category-thumb-clickable"
              (click)="openImagePreview(currentImageUrl)" />
            <label class="btn btn-sm btn-outline-primary mb-0" style="cursor:pointer;">
              <i class="fa fa-upload mx-1"></i>
              {{ curentLang === 'en' ? 'Upload' : (curentLang === 'ar' ? 'رفع' : 'העלה') }}
              <input type="file" accept="image/*" style="display:none;" (change)="onImageSelected($event)" />
            </label>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="upd_cat_ai" formControlName="generate_ai_image" />
              <label class="form-check-label" for="upd_cat_ai" style="color:grey;">
                {{ curentLang === 'en' ? 'Generate AI on save (from name)' : (curentLang === 'ar' ? 'توليد AI عند الحفظ (من الاسم)' : 'צור AI בשמירה (מהשם)') }}
              </label>
            </div>
            <input class="form-control form-control-sm" style="max-width:280px;" type="text"
              formControlName="ai_image_prompt"
              placeholder="{{ curentLang === 'en' ? 'Custom AI prompt (optional)' : (curentLang === 'ar' ? 'برومبت يدوي (اختياري)' : 'פרומפט ידני (אופציונלי)') }}" />
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="generateAiImage()">
              <i class="fa fa-magic mx-1"></i>
              {{ curentLang === 'en' ? 'Preview AI' : (curentLang === 'ar' ? 'معاينة AI' : 'תצוגת AI') }}
            </button>
            <small *ngIf="pendingPreviewKey" class="text-success">
              {{ curentLang === 'en' ? 'Preview ready — will apply on save' : (curentLang === 'ar' ? 'المعاينة جاهزة — تُعتمد عند الحفظ' : 'התצוגה מוכנה — תוחל בשמירה') }}
            </small>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm" style="background:#141414;color:#fff;" (click)="updateById()">
          {{ curentLang === 'en' ? 'Confirm' : (curentLang === 'ar' ? 'تأكيد' : 'אישור') }}
        </button>
        <button type="button" class="btn btn-sm btn-danger" (click)="modal.close()">
          {{ curentLang === 'en' ? 'Back' : (curentLang === 'ar' ? 'رجوع' : 'חזרה') }}
        </button>
      </div>
    </form>
  </div>
</ng-template>

<!-- View -->
<ng-template #viewData let-modal>
  <div class="modal-header d-flex justify-content-between">
    <h6 class="modal-title" style="color:grey;">
      {{ curentLang === 'en' ? 'View Category' : (curentLang === 'ar' ? 'عرض التصنيف' : 'צפייה בקטגוריה') }}
    </h6>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="updateForm">
      <div class="row">
        <div class="mb-3 col-md-12" *ngIf="currentImageUrl">
          <label class="form-label" style="color:grey;">
            {{ curentLang === 'en' ? 'Image' : (curentLang === 'ar' ? 'الصورة' : 'תמונה') }}
          </label>
          <div>
            <img [src]="currentImageUrl" alt="" class="category-image-preview category-thumb-clickable"
              (click)="openImagePreview(currentImageUrl)" />
          </div>
        </div>
        <div class="mb-3 col-md-12">
          <label class="form-label" style="color:grey;">
            {{ curentLang === 'en' ? 'Name' : (curentLang === 'ar' ? 'الاسم' : 'שם') }}
          </label>
          <input class="form-control" formControlName="name" readonly />
        </div>
        <div class="mb-3 col-md-6">
          <label class="form-label" style="color:grey;">{{ curentLang === 'en' ? 'Code' : (curentLang === 'ar' ? 'الكود' : 'קוד') }}</label>
          <input class="form-control" formControlName="code" readonly />
        </div>
        <div class="mb-3 col-md-6">
          <label class="form-label" style="color:grey;">{{ curentLang === 'en' ? 'Sort Order' : (curentLang === 'ar' ? 'الترتيب' : 'סדר') }}</label>
          <input class="form-control" type="number" formControlName="sort_order" readonly />
        </div>
      </div>
    </form>
  </div>
</ng-template>

<!-- Delete -->
<ng-template #dataDeleted let-modal>
  <div class="modal-header">
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="text-center text-danger">
      <i class="fa fa-trash text-danger"></i>
      {{ curentLang === 'en' ? 'Are you sure you want to delete it?' : (curentLang === 'ar' ? 'هل تريد بالتأكيد حذفه؟' : 'האם אתה בטוח שברצונך למחוק אותו?') }}
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm" style="background:#141414;color:#fff;" (click)="deleteById()">
      {{ curentLang === 'en' ? 'Confirm' : (curentLang === 'ar' ? 'تأكيد' : 'אישור') }}
    </button>
    <button type="button" class="btn btn-sm btn-danger" (click)="modal.close()">
      {{ curentLang === 'en' ? 'Back' : (curentLang === 'ar' ? 'رجوع' : 'חזרה') }}
    </button>
  </div>
</ng-template>

<!-- AI Preview -->
<ng-template #aiPreviewModal let-modal>
  <div class="modal-header d-flex justify-content-between">
    <h6 class="modal-title" style="color:grey;">
      {{ curentLang === 'en' ? 'AI Image Preview' : (curentLang === 'ar' ? 'معاينة صورة AI' : 'תצוגה מקדימה של תמונת AI') }}
    </h6>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body text-center">
    <img *ngIf="aiPreviewUrl" [src]="aiPreviewUrl" alt="AI preview" class="category-ai-preview" />
    <p class="text-muted mt-2 mb-0">
      {{ curentLang === 'en' ? 'Approve to use this image on the category.' : (curentLang === 'ar' ? 'اعتمد لاستخدام هذه الصورة على التصنيف.' : 'אשר כדי להשתמש בתמונה בקטגוריה.') }}
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm" style="background:#141414;color:#fff;" (click)="approveAiImage(modal)">
      {{ curentLang === 'en' ? 'Approve' : (curentLang === 'ar' ? 'اعتماد' : 'אישור') }}
      <i class="fa fa-check-circle mx-1"></i>
    </button>
    <button type="button" class="btn btn-sm btn-danger" (click)="modal.close()">
      {{ curentLang === 'en' ? 'Cancel' : (curentLang === 'ar' ? 'إلغاء' : 'ביטול') }}
    </button>
  </div>
</ng-template>

<!-- Image preview -->
<ng-template #imageViewModal let-modal>
  <div class="modal-header d-flex justify-content-between">
    <h6 class="modal-title" style="color:grey;">
      {{ curentLang === 'en' ? 'Category Image' : (curentLang === 'ar' ? 'صورة التصنيف' : 'תמונת קטגוריה') }}
    </h6>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body text-center">
    <img *ngIf="imageViewUrl" [src]="imageViewUrl" alt="" class="category-image-full" />
  </div>
</ng-template>
